import gsx from 'styles'

const styles = {
  root: {
  },

  internalSection: {
    '& .MuiPaper-root': {
      background: { md: 'white' },
      border: { md: '1px solid #F1F1F1' },
      borderRadius: '2px',
    },
  },
  googleReviewsContainer: {
    '& > .MuiGrid-container': {
      ...gsx.googleReviewsContainer,
      marginTop: 3,
      marginBottom: 6,
    },
  },

}

export default styles
